import { createContext, useContext, useMemo, type ReactNode } from 'react'

interface BasicTableExpansionContextValue {
  /**
   * When true, every BasicTable rendered inside the provider forces all of its
   * expandable rows open (showing their Updates and Tracking content) regardless
   * of the table's own per-row expansion state. Used to render a fully expanded
   * budget PDF. Defaults to false, so tables outside a provider behave normally.
   */
  forceExpandAll: boolean
}

const BasicTableExpansionContext = createContext<BasicTableExpansionContextValue>({ forceExpandAll: false })

export const useBasicTableExpansion = (): BasicTableExpansionContextValue => useContext(BasicTableExpansionContext)

interface ProviderProps {
  forceExpandAll: boolean
  children: ReactNode
}

export const BasicTableExpansionProvider = ({ forceExpandAll, children }: ProviderProps): JSX.Element => {
  const value = useMemo(() => ({ forceExpandAll }), [forceExpandAll])
  return <BasicTableExpansionContext.Provider value={value}>{children}</BasicTableExpansionContext.Provider>
}
